import type { GridColDef } from '@mui/x-data-grid';
import type { InvoiceOverview } from '@weft/api-definition';
import { formatDate } from 'apps/app/src/utils/date';
import type { FieldPath } from 'react-hook-form';
import { Price } from '../../../../../../components/design/Price';

export const SYNC_INVOICES_COLUMNS_KEYS = Object.freeze({
  CUSTOMER_NAME: 'customer.name',
  TOTAL_AMOUNT: 'revenueBreakdown.total',
  ID: 'id',
  ISSUED_AT: 'issuedAt',
} satisfies Record<string, FieldPath<InvoiceOverview>>);

export const SYNC_INVOICES_COLUMNS: GridColDef<InvoiceOverview>[] = [
  {
    field: SYNC_INVOICES_COLUMNS_KEYS.CUSTOMER_NAME,
    valueGetter: ({ row }) => row.customer.name,
    headerName: 'Customer name',
    flex: 1,
    renderCell: ({ value }) => (
      <span className="font-sans text-black">
        {value}
      </span>
    ),
  },
  {
    field: SYNC_INVOICES_COLUMNS_KEYS.TOTAL_AMOUNT,
    headerName: 'Amount',
    flex: 1,
    renderCell: ({ row }) => {
      const amount = row.revenueBreakdown.total;
      const currency = row.currency;

      return (
        <span className="text-label font-sans">
          <Price
            currency={currency}
            className="font-sans text-black"
          >
            {amount}
          </Price>
        </span>
      );
    },
  },
  {
    field: SYNC_INVOICES_COLUMNS_KEYS.ID,
    valueGetter: ({ row }) => row.id,
    headerName: 'Invoice',
    flex: 1,
    renderCell: ({ value }) => (
      <span className="font-sans text-black">
        {value?.slice(-5)}
      </span>
    ),
  },
  {
    field: SYNC_INVOICES_COLUMNS_KEYS.ISSUED_AT,
    headerName: 'Invoice date',
    flex: 1,
    valueGetter: ({ row }) => formatDate(row.issuedAt),
  },
];
